export const DEFAULT_INITIAL_SETTINGS = {
  selectors: {
    header: '#header.hero',
  },
  classNames: {
    down: 'down',
    up: 'up',
    focus: 'focus',
  },
  breakpoints: {
    xs: 400,
    s: 640,
    ms: 770,
    md: 980,
    lg: 1090,
    xl: 1140,
    mxl: 1380,
    xxl: 1480,
    xxxl: 1680,
  },
  animations: {
    ['OPTIONS_HOME_TIME_BODY']: 400,
    ['OPTIONS_DEFAULT_TIME_BODY']: 600,
  },
}
